module.exports = __webpack_public_path__ + "static/media/more.b15ef418.svg";